import i18n from "i18next";
import { initReactI18next } from "react-i18next";
// import { DateTime } from "luxon";

import Backend from "i18next-http-backend";
import LanguageDetector from "i18next-browser-languagedetector";

const initialLanguage = localStorage.getItem("selectedLanguage") || "en";

i18n
  // load translation using http -> see /public/locales (i.e. https://github.com/i18next/react-i18next/tree/master/example/react/public/locales)
  // learn more: https://github.com/i18next/i18next-http-backend
  // want your translations to be loaded from a professional CDN? => https://github.com/locize/react-tutorial#step-2---use-the-locize-cdn
  .use(Backend)
  // detect user language
  // learn more: https://github.com/i18next/i18next-browser-languageDetector
  .use(LanguageDetector, {
    order: [
      "querystring",
      "cookie",
      "localStorage",
      "navigator",
      "htmlTag",
      "path",
      "subdomain",
    ],
  })
  // pass the i18n instance to react-i18next.
  .use(initReactI18next)
  // init i18next
  // for all options read: https://www.i18next.com/overview/configuration-options
  .init({
    debug: true,
    fallbackLng: "en",
    ns: ["translation"],
    defaultNS: "translation",
    lng: initialLanguage,
    backend: {
      loadPath: "/locales/{{lng}}/{{ns}}.json",
    },
    interpolation: {
      escapeValue: false, // not needed for react as it escapes by default
    },
  });

// Listen for language changes and store the selected language in localStorage
i18n.on("languageChanged", (lng) => {
  localStorage.setItem("selectedLanguage", lng);
  document.documentElement.dir = lng === 'ar' ? 'rtl' : 'ltr';
});

// i18n.services.formatter.add("DATE_HUGE", (value, lng, options) => {
// return DateTime.fromJSDate(value);
// .setLocale(lng)
// .toLocaleString(DateTime.DATE_HUGE)
// });

export default i18n;
